function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "PM_LOGO_1_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M93.745,0H1.265C0.566,0,0,0.506,0,1.131v56.891c0,0.625,0.566,1.131,1.265,1.131h92.479 c0.699,0,1.266-0.506,1.266-1.131V1.131C95.01,0.506,94.444,0,93.745,0z M87.631,52.345h-0.196h-5.987H13.334H7.442H7.438V6.785 h18.48c9.302,0,13.955,4.067,13.955,12.2c0,8.859-6.362,14.264-19.084,16.219l-1.212-4.971 c9.347-1.381,14.019-5.045,14.019-10.992c0-5.055-2.74-7.581-8.221-7.581l-12.042-0.003v34.771h68.114V21.908L68.89,34.421 L50.101,15.537V6.823L68.89,25.566L87.631,6.823V52.345z M47.439,28.549l10.39,10.39H37.049L47.439,28.549z"
})));

var SvgPmLogo = function SvgPmLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    width: "95.01px",
    height: "59.152px",
    viewBox: "0 0 95.01 59.152",
    enableBackground: "new 0 0 95.01 59.152",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPmLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PMLogo.5213eafd.svg";
export { ForwardRef as ReactComponent };